import { Component, OnInit } from "@angular/core";
import { REZROUTES } from "./sidebar-routes-rez.config";
import { PASSROUTES } from "./sidebar-routes-pass.config";
import { ORDERINGROUTES } from "./sidebar-routes-ordering.config";
import { QUEUEGROUTES } from "./sidebar-routes-queue.config";
import { WEDDINGGROUTES } from "./sidebar-routes-wedding.config";
import { RouteInfo } from "./sidebar.metadata";
import { AuthService } from "../auth/auth.service";
import { LookupService } from "../services/lookup.service";
import { Subscription } from "rxjs";
import { ReservationupdaterService } from "@foh/shared/services/reservationupdater.service";
import { Globals } from "@foh/globals";
import { warning } from "@foh/shared/data/sweet-alerts";
import { ReservationsService } from "@foh/reservations/reservations.service";
import { FohmoduleSelectorService } from "@foh/shared/services/fohmodule-selector.service";
import { Router } from "@angular/router";
declare var $: any;
@Component({
  // moduleId: module.id,
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  reservationUpdaterListener: Subscription;
  currentVersion: string;
  nextBillingDate: any;
  currentSelectedModule: string;
  shouldDisplaySwitchToRezOption: boolean = false;
  shouldDisplaySwitchToPassOption: boolean = false;
  shouldDisplaySwitchToOrderingOption: boolean = false;
  shouldDisplaySwitchToQueueOption: boolean = false;
  shouldDisplaySwitchToCitadelOption: boolean = false;
  constructor(
    private authService: AuthService,
    private reservationupdaterService: ReservationupdaterService,
    private globals: Globals,
    private reservationsService: ReservationsService,
    private fohmoduleSelectorService: FohmoduleSelectorService,
    private lookupService: LookupService,
    private router: Router
  ) {
    this.bindReservationUpdaterEvents();
    this.currentVersion = this.globals.CURRENT_VERSION;
  }

  filterRoutes(menuItems) {
    var i = menuItems.length;
    var user = this.authService.getUser();
    var currentModule = this.fohmoduleSelectorService.getCurrentModule();
    var role = null;

    // Get the current role for this module
    if (user && user.roles && user.roles.length) {
      for (var j = 0; j < user.roles.length; j++) {
        if (user.roles[j].module === currentModule) {
          role = user.roles[j].name;
          break;
        }
      }
    }
    if (role === "FOH-Finance-Only") {
      return [
        {
          alias: "sms-transactions",
          path: "",
          title: "Transactions",
          icon: "",
          class: "has-sub",
          badge: "",
          badgeClass: "",
          isExternalLink: false,
          submenu: [
            {
              path: "/super-admin-board/sms-transactions",
              title: "SMS Transactions",
              icon: "",
              class: "",
              badge: "",
              badgeClass: "",
              isExternalLink: false,
              submenu: [],
            },
            {
              path: "/super-admin-board/whatsApp-transactions",
              title: "Whatsapp Transactions",
              icon: "",
              class: "",
              badge: "",
              badgeClass: "",
              isExternalLink: false,
              submenu: [],
            },
          ],
        },
      ];
    }
    while (i--) {
      // const item = menuItems[i];

      // // Hide "Switch to Pass" route if user is SuperAdmin
      // if (item.path === '/module/switchto/pass' && this.authService.isSuperAdmin()) {
      //   menuItems.splice(i, 1);
      //   continue;
      // }

      if (menuItems[i].path == "/rez/feedback-form") {
        // Show only for mCompany 24 or 98 or 76
        let mCompany = this.lookupService.getMCompany().id;
        if (mCompany === 24 || mCompany === 98 || mCompany === 76) {
          continue;
        } else {
          menuItems.splice(i, 1);
          continue;
        }
      }

      if (
        !this.authService.isSuperAdmin() &&
        !this.lookupService.haveValidLicense &&
        (typeof menuItems[i].subscriptionItem === "undefined" ||
          menuItems[i].subscriptionItem !== true)
      ) {
        //If no valid license, skip
        menuItems.splice(i, 1);
        continue;
      }
      if (
        menuItems[i].isSuperAdmin === true &&
        !this.authService.isSuperAdmin()
      ) {
        menuItems.splice(i, 1);
        continue;
      }
      if (typeof menuItems[i].permissions !== "undefined") {
        var haveAccess = this.havePermission(menuItems[i].permissions);
        if (!haveAccess) {
          menuItems.splice(i, 1);
          continue;
        }
      }
      if (menuItems[i].submenu.length > 0) {
        menuItems[i].submenu = this.filterRoutes(menuItems[i].submenu);
      }
    }

    return menuItems;
  }

  havePermission(permissions) {
    var onlyOneFound = false;
    if (this.authService.isSuperAdmin()) {
      return true;
    }
    for (var i = 0; i < permissions.length; i++) {
      if (this.authService.havePermission(permissions[i])) {
        onlyOneFound = true;
        break;
      }
    }
    return onlyOneFound;
  }

  injectReservationsRoutes() {
    if (
      !this.authService.isSuperAdmin() &&
      !this.lookupService.haveValidLicense
    ) {
      //If no valid license, skip
      return;
    }
    var venueLength = this.lookupService.getNumberOfValidVenues();
    var venues = this.lookupService.getVenues();
    var firstVenue = venues[0];
    let numberOfLevels: number;
    let anyVenueHaveMoreThanOneBranch: boolean;
    if (venueLength > 1) {
      //Check If Any Venue have more than one branches
      anyVenueHaveMoreThanOneBranch =
        this.venueHaveAtleastMoreThanOneBranch(venues);
      if (anyVenueHaveMoreThanOneBranch) {
        numberOfLevels = 2;
      } else {
        numberOfLevels = 1;
      }
    } else if (
      venueLength == 1 &&
      this.lookupService.getNumberOfBranchesOfVenue(firstVenue) > 1
    ) {
      numberOfLevels = 1;
    } else {
      numberOfLevels = 0;
    }

    switch (numberOfLevels) {
      case 2:
        this.injectTwoLevelsReservationRoutes(venues, "reservations");
        this.injectTwoLevelsReservationRoutes(venues, "guestbook");
        break;
      case 1:
        if (venueLength > 1 && !anyVenueHaveMoreThanOneBranch) {
          this.injectOneLevelReservationRoutesVenueOnly(venues, "reservations");
          this.injectOneLevelReservationRoutesVenueOnly(venues, "guestbook");
        } else {
          this.injectOneLevelReservationRoutes(firstVenue, "reservations");
          this.injectOneLevelReservationRoutes(firstVenue, "guestbook");
        }
        break;
      case 0:
        this.injectZeroLevelReservationRoutes(firstVenue, "reservations");
        this.injectZeroLevelReservationRoutes(firstVenue, "guestbook");
        break;
    }
  }

  venueHaveAtleastMoreThanOneBranch(venues) {
    var haveMoreThanOneBranch = false;
    for (var i = 0; i < venues.length; i++) {
      if (venues[i].branches.length > 1) {
        haveMoreThanOneBranch = true;
        break;
      }
    }
    return haveMoreThanOneBranch;
  }

  injectTwoLevelsReservationRoutes(venues, alias) {
    var array = this.fillVenueInfo(venues, alias);
    var reservationPath = this.getRoutePathByAlias(alias);
    reservationPath.class = "has-sub";
    reservationPath.submenu = array;
  }
  injectOneLevelReservationRoutesVenueOnly(venues, alias) {
    var array = this.fillSingleBranchVenueInfoForVenue(venues, alias);
    var reservationPath = this.getRoutePathByAlias(alias);
    reservationPath.class = "has-sub";
    reservationPath.submenu = array;
  }
  injectOneLevelReservationRoutes(venue, alias) {
    var array = this.fillBranchInfoForVenue(venue, alias);
    var reservationPath = this.getRoutePathByAlias(alias);
    reservationPath.class = "has-sub";
    reservationPath.submenu = array;
  }
  fillVenueInfo(venues, alias) {
    var array = [];
    for (var i = 0; i < venues.length; i++) {
      var arrayOfBrunches = this.fillBranchInfoForVenue(venues[i], alias);
      var jsonObject = {};
      jsonObject["path"] = "";
      jsonObject["title"] = venues[i]["name"];
      jsonObject["icon"] = "";
      jsonObject["class"] = "has-sub";
      jsonObject["badge"] = "";
      jsonObject["badgeClass"] = "";
      jsonObject["isExternalLink"] = false;
      jsonObject["submenu"] = arrayOfBrunches;
      array.push(jsonObject);
    }

    return array;
  }
  fillSingleBranchVenueInfoForVenue(venues, alias) {
    var array = [];
    for (var i = 0; i < venues.length; i++) {
      var jsonObject = {};
      jsonObject["path"] = this._getReservationGuestbookLink(
        alias,
        venues[i].branches[0]["id"]
      );
      jsonObject["title"] = venues[i]["name"];
      jsonObject["icon"] = "";
      jsonObject["class"] = "";
      jsonObject["badge"] = "";
      jsonObject["badgeClass"] = "";
      jsonObject["isExternalLink"] = false;
      jsonObject["submenu"] = [];
      array.push(jsonObject);
    }
    return array;
  }
  fillBranchInfoForVenue(venue, alias) {
    var array = [];
    for (var i = 0; i < venue.branches.length; i++) {
      var jsonObject = {};
      jsonObject["path"] = this._getReservationGuestbookLink(
        alias,
        venue.branches[i]["id"]
      );
      jsonObject["title"] = venue.branches[i]["name"];
      jsonObject["icon"] = "";
      jsonObject["class"] = "";
      jsonObject["badge"] = "";
      jsonObject["badgeClass"] = "";
      jsonObject["isExternalLink"] = false;
      jsonObject["submenu"] = [];
      array.push(jsonObject);
    }
    return array;
  }

  _getReservationGuestbookLink(alias, id) {
    if (alias == "guestbook") {
      return "/" + alias + "/" + id;
    } else if (alias == "reservations") {
      var currentView = this.reservationsService.currentDefaultView();
      if (currentView == "legacy") {
        return "/" + alias + "/legacy/" + id;
      }
      return "/" + alias + "/" + id;
    }
  }
  injectZeroLevelReservationRoutes(venue, alias) {
    var reservationPath = this.getRoutePathByAlias(alias);
    reservationPath["path"] = this._getReservationGuestbookLink(
      alias,
      venue.branches[0].id
    );
  }

  getRoutePathByAlias(alias) {
    var found: any = false;
    for (var i = 0; i < this.menuItems.length; i++) {
      if (typeof this.menuItems[i].alias !== "undefined") {
        if (this.menuItems[i].alias === alias) {
          found = this.menuItems[i];
          break;
        }
      }
      for (var j = 0; j < this.menuItems[i].submenu.length; j++) {
        if (typeof this.menuItems[i].submenu[j].alias !== "undefined") {
          if (this.menuItems[i].submenu[j].alias === alias) {
            found = this.menuItems[i].submenu[j];
            break;
          }
        }
      }
    }
    return found;
  }

  getIndexOfRootPathByAlias(array, alias) {
    var found: any = false;
    for (var i = 0; i < array.length; i++) {
      if (typeof array[i].alias !== "undefined") {
        if (array[i].alias === alias) {
          found = i;
          break;
        }
      }
    }
    return found;
  }

  initializeSidebar() {
    this.handleModuleSelection(); // sets the theme and current module
    this.currentSelectedModule =
      this.fohmoduleSelectorService.getCurrentModule();

    const currentRoutes = this.selectCurrentRoutes(); // sets switch module etc.
    this.menuItems = this.filterRoutes(
      currentRoutes.filter((menuItem) => menuItem)
    );

    this.checkLicenseAlertStatus();
    this.updatePendingRequestsNumber(
      this.lookupService.vars["pendingRequestsCounter"]
    );
  }

  ngOnInit() {
    $.getScript("./assets/js/app-sidebar.js");

    if (this.lookupService.lookupLoaded) {
      this.initializeSidebar();
    } else {
      const checkLoadedInterval = setInterval(() => {
        if (this.lookupService.lookupLoaded) {
          clearInterval(checkLoadedInterval);
          this.initializeSidebar();
        }
      }, 100);
    }
  }

  ngAfterViewInit() {
    const selectedModule = this.fohmoduleSelectorService.getCurrentModule();
    setTimeout(() => {
      this.applyTheme(selectedModule);
    });
  }

  //  selectCurrentRoutes(): RouteInfo[] {
  //   const mCompany = this.lookupService.getMCompany();
  //   const hasRez = mCompany.rez === 1;
  //   const hasQueue = mCompany.queue === 1;

  //   let routes: RouteInfo[] = [];

  //   if (hasRez && hasQueue) {
  //     this.currentSelectedModule = 'rez';
  //     routes = this.mergeQueueIntoRezRoutes(REZROUTES, QUEUEGROUTES);
  //   } else {
  //     switch (this.currentSelectedModule) {
  //       case "rez":
  //         routes = REZROUTES;
  //         break;
  //       case "pass":
  //         routes = PASSROUTES;
  //         break;
  //       case "ordering":
  //         routes = ORDERINGROUTES;
  //         break;
  //       case "queue":
  //         routes = QUEUEGROUTES;
  //         break;
  //       case "wedding":
  //         routes = WEDDINGGROUTES;
  //         break;
  //     }
  //   }

  //   this.injectSwitchToModuleRoutes(routes);
  //   return routes;
  // }
  selectCurrentRoutes(): RouteInfo[] {
    const currentModule = this.fohmoduleSelectorService.getCurrentModule();
    this.currentSelectedModule = currentModule;

    const mCompany = this.lookupService.getMCompany();
    const hasRez = mCompany.rez === 1;
    const hasQueue = mCompany.queue === 1;

    let routes: RouteInfo[] = [];

    switch (currentModule) {
      case "rez":
        routes =
          hasRez && hasQueue
            ? this.mergeQueueIntoRezRoutes(REZROUTES, QUEUEGROUTES)
            : REZROUTES;
        break;
      case "pass":
        routes = PASSROUTES;
        break;
      case "ordering":
        routes = ORDERINGROUTES;
        break;
      case "queue":
        routes = QUEUEGROUTES;
        break;
      case "wedding":
        routes = WEDDINGGROUTES;
        break;
      default:
        routes = []; // Fallback
    }

    this.injectSwitchToModuleRoutes(routes);
    return routes;
  }

  injectSwitchToModuleRoutes(routes) {
    this.refreshSwitchToFlags(); // now this will work correctly

    const switchModulePathIndex = this.getIndexOfRootPathByAlias(
      routes,
      "switchmodule"
    );
    if (switchModulePathIndex !== false) {
      routes.splice(switchModulePathIndex, 1);
    }

    if (
      !this.shouldDisplaySwitchToRezOption &&
      !this.shouldDisplaySwitchToPassOption &&
      !this.shouldDisplaySwitchToOrderingOption &&
      !this.shouldDisplaySwitchToQueueOption &&
      !this.shouldDisplaySwitchToCitadelOption
    ) {
      return;
    }

    const subRoutes: RouteInfo[] = [];
    if (this.shouldDisplaySwitchToRezOption)
      this.addSwitchToSubRoute(subRoutes, "rez", "Rez");
    if (this.shouldDisplaySwitchToPassOption)
      this.addSwitchToSubRoute(subRoutes, "pass", "Pass");
    if (this.shouldDisplaySwitchToOrderingOption)
      this.addSwitchToSubRoute(subRoutes, "ordering", "Ordering");
    if (this.shouldDisplaySwitchToQueueOption)
      this.addSwitchToSubRoute(subRoutes, "queue", "Queue");
    if (this.shouldDisplaySwitchToCitadelOption)
      this.addSwitchToSubRoute(subRoutes, "wedding", "Citadel");

    const parentRoute: RouteInfo = {
      alias: "switchmodule",
      path: "",
      title: "Switch Module",
      icon: "fa fa-map-signs",
      class: "has-sub",
      badge: "",
      badgeClass: "",
      isExternalLink: false,
      submenu: subRoutes,
    };

    routes.push(parentRoute);
  }

  addSwitchToSubRoute(subRoutes, module, title) {
    let subRoute: RouteInfo = {
      path: "/module/switchto/" + module,
      title: "Switch To " + title,
      icon: "",
      class: "",
      badge: "",
      badgeClass: "",
      isExternalLink: false,
      submenu: [],
    };
    subRoutes.push(subRoute);
  }
  handleModuleSelection() {
    const mCompany = this.lookupService.getMCompany();
    const currentModule = this.fohmoduleSelectorService.getCurrentModule();

    const hasQueue = mCompany.queue === 1;
    const hasRez = mCompany.rez === 1;
    const hasPass = mCompany.pass === 1;

    let targetModule = currentModule;
    let redirectPath = "";

    if (currentModule === "rez" && !hasRez && hasQueue) {
      targetModule = "queue";
      redirectPath = "/customers/list";
    } else if (currentModule === "queue" && !hasQueue && hasRez) {
      targetModule = "rez";
      redirectPath = "/rez/dashboard";
    } else if (currentModule === "pass" && hasPass) {
      targetModule = "pass";
      redirectPath = "/pass/events/list";
    } else if (hasRez && hasQueue) {
      targetModule = "rez";
      redirectPath = "/rez/dashboard";
    }

    if (targetModule !== currentModule) {
      this.fohmoduleSelectorService.setModule(targetModule);

      setTimeout(() => {
        window.location.href = redirectPath;
      }, 100);
    } else {
      this.applyTheme(currentModule);
    }
  }

  refreshSwitchToFlags() {
    this.shouldDisplaySwitchToRezOption = this.checkSwitchToFlag("rez");
    this.shouldDisplaySwitchToPassOption = this.checkSwitchToFlag("pass");
    this.shouldDisplaySwitchToOrderingOption =
      this.checkSwitchToFlag("ordering");
    this.shouldDisplaySwitchToQueueOption = this.checkSwitchToFlag("queue");
    this.shouldDisplaySwitchToCitadelOption = this.checkSwitchToFlag("wedding");
  }

  checkSwitchToFlag(module) {
    if (this.currentSelectedModule == module) {
      return false;
    }
    //Here, We should check if mcompany have access
    var mCompany = this.lookupService.getMCompany();
    if (mCompany[module] != 1) {
      return false;
    }
    if (module === "queue" && mCompany.rez === 1 && mCompany.queue === 1) {
      return false;
    }
    //Then check if user nfso 3ndo access
    return this.authService.accessToFohModule(module);
  }

  updatePendingRequestsNumber(newCounter) {
    var route = this.getRoutePathByAlias("requests");
    if (route != false) {
      route.badge = newCounter;
    }
  }

  updatePendingQueuesNumber(newCounter) {
    var route = this.getRoutePathByAlias("queue");
    if (route != false) {
      route.badge = newCounter;
    }
  }

  bindReservationUpdaterEvents() {
    this.reservationUpdaterListener = this.reservationupdaterService
      .listen()
      .subscribe((event) => {
        if (event.type == "pendingrequests-counter-update") {
          var newCounter = event.newCounter;
          this.updatePendingRequestsNumber(newCounter);
        }
        if (event.type == "pendingqueues-counter-update") {
          var newCounter = event.newCounter;
          this.updatePendingQueuesNumber(newCounter);
        }
      });
  }

  checkLicenseAlertStatus() {
    if (
      this.lookupService.licenseHaveAlertWarning &&
      !this.authService.isSuperAdmin()
    ) {
      this.showWarningMessage();
      setTimeout(() => {
        this.showWarningMessage();
      }, 300000);
    }
  }

  showWarningMessage() {
    warning(
      "License Expired",
      "We were not able to process the subscription renewal through the credit card in file, Please update it asap to avoid interruption of service."
    );
  }
  applyTheme(module: string) {
    document.body.classList.remove(
      "theme-rez",
      "theme-queue",
      "theme-pass",
      "theme-ordering",
      "theme-wedding"
    );
    document.body.classList.add(`theme-${module}`);
  }

  mergeQueueIntoRezRoutes(
    rezRoutes: RouteInfo[],
    queueRoutes: RouteInfo[]
  ): RouteInfo[] {
    const mergedRoutes = [...rezRoutes];

    // Find the 'Settings' route
    const settingsRoute = mergedRoutes.find(
      (route) => route.title === "Settings" || route.alias === "settings"
    );
    if (!settingsRoute || !Array.isArray(settingsRoute.submenu))
      return mergedRoutes;

    // Find the 'Rez & Guest Management' submenu under 'Settings'
    const rezGuestRoute = settingsRoute.submenu.find(
      (sub) => sub.title === "Rez & Guest Management"
    );
    if (!rezGuestRoute || !Array.isArray(rezGuestRoute.submenu))
      return mergedRoutes;

    const index = mergedRoutes.findIndex(
      (r) => r.alias === "requests" || r.title === "Requests"
    );
    rezGuestRoute.submenu.splice(1, 0, {
      path: "/rez/queue-form",
      title: "Queue Form",
      icon: "",
      class: "",
      badge: "",
      badgeClass: "",
      isExternalLink: false,
      submenu: [],
    });

    const queueRoute: RouteInfo = {
      path: "/rez/queue",
      title: "Queue",
      icon: "fa fa-exchange",
      class: "",
      badge: "",
      badgeClass: "",
      isExternalLink: false,
      submenu: [],
    };
    if (index !== -1) {
      mergedRoutes.splice(index + 1, 0, queueRoute);
    } else {
      mergedRoutes.push(queueRoute);
    }

    return mergedRoutes;
  }
}
